import Vue from 'vue'
import VueRouter from 'vue-router'
import cookie from 'js-cookie'
import ls from 'local-storage'
import store from '@/store'
import {MessageBox} from 'element-ui';

import registerRouter from './modules/register'; //注册管理路由
import activityRouter from './modules/activity'; //演出管理路由
import workbenchRouter from './modules/workbench'; //工作台路由管理
import raiseRouter from './modules/raise';//众筹管理路由
import financeRouter from './modules/finance'; //财务管理路由
import dashboardRouter from './modules/dashboard'; //数据分析路由
import goodsRouter from './modules/goods'; //数据分析路由
import entranceRouter from './modules/entrance'; //入场数据
import TicketcheckRouter from './modules/Ticketcheck'; //入场数据
import entryDataRouter from './modules/entryData'; //入场数据
import viteDataRouter from './modules/viteData'; //邀请函数据数据
import smsMarketingRouter from './modules/smsMarketing'; //数据分析路由
import couponRouter from './modules/coupon'; //优惠券路由
import siteRouter from './modules/site'; //场地预定路由
import shareActivityRouter from './modules/shareActivity'; //分享活动路由
import contractAdminRouter from './modules/contractAdmin'; //合同治理路由
// import modules from './modules'

Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login'),
        meta: {
            requireAuth: false
        }
    },{
        path:'/login/auto',
        name: 'login-auto',
        component: () => import('@/views/login/auto'),
        meta: {
            requireAuth: false
        }
    },{
        path:'/login/lostpwd',
        name: 'login-lostpwd',
        component: () => import('@/views/login/lostpwd'),
        meta: {
            requireAuth: false
        }
    },{
        path:'/error',
        component: () => import('@/layout/default'),
        meta: {
            requireAuth: false
        },
        children:[{
            path: '404',
            name: '404',
            component: () => import('@/views/error/404'),
            meta: {
                breadcrumb: false
            }
        }]
        
    },{
        path: '/',
        component: () => import('@/views/index'),
        redirect: '/index',
        meta: {
            requireAuth: false
        },
        children:[{
            path: 'index',
            name: 'index',
            component: () => import('@/views/index'),
        }]
    },
    {
        path: '/showstartRelease',
        component: () => import('@/layout/default'),
        children:[{
            path:'',
            name: 'showstartRelease',
            component: () => import('@/views/showstartRelease'),
        }]
    },
    {
        path: '/ticketCode',
        component: () => import('@/layout/default'),
        children:[{
            path:'',
            name: 'ticketCode',
            component: () => import('@/views/ticketCode'),
        }]
    },
    {
        path: '/manage',
        component: () => import('@/layout/manage'),
        redirect: '/manage/home',
        meta: {
            requireAuth: true
        },
        children: [
            {
                path: 'home',
                name: 'manageHome',
                component: () => import('@/views/manage/home')
            },
            activityRouter,
            workbenchRouter,
            raiseRouter,
            financeRouter,
			dashboardRouter,
            goodsRouter,
			smsMarketingRouter,
			couponRouter,
			siteRouter,
			shareActivityRouter
        ]
    },
	{
	    path: '/manage',
	    component: () => import('@/layout/manage'),
	    redirect: '/manage/lpa',
	    meta: {
	        requireAuth: true
	    },
	    children: [
	        {
	            path: 'lpa',
	            name: 'lpa',
	            component: () => import('@/views/manage/lpa')
	        },
	        activityRouter,
	        workbenchRouter,
	        raiseRouter,
	        financeRouter,
			dashboardRouter,
	        goodsRouter,
			smsMarketingRouter,
			couponRouter
	    ]
	},
    registerRouter,
    entranceRouter,
    TicketcheckRouter,
    entryDataRouter,
	viteDataRouter,
    contractAdminRouter,
    {path: '*', redirect: '/error/404', meta: {breadcrumb: false}}
]

//使用push()、replace()进行导航时，不能重复导航到当前路由。
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
    mode: 'history',
    scrollBehavior: () => ({ x: 0, y: 0 }),
    routes
})

//登录拦截
router.beforeEach((to, from, next) => {
    if (to.matched.some(r => r.meta.requireAuth)) {
        if (to.path === '/login') return next()
        const _sign = cookie.get('CUSUT');
        if (_sign) {
            if (!store.state.CUSUT) {
                store.commit('setCUSUT', _sign);
            }
            // 路由级权限: 带 meta.privilege 的路由需命中登录用户 priviList
            // (与后端接口权限同源 sudu_privilege; 未配置该 meta 的路由仅要求登录)
            const _privRoute = to.matched.find(r => r.meta.privilege);
            if (_privRoute) {
                const _privs = ls.get('priviList') || [];
                if (!_privs.find(v => v === _privRoute.meta.privilege)) {
                    return next('/error/404');
                }
            }
            next();

        } else {
            next({
                path: '/login',
                query: {
                    redirect: to.fullPath
                }
            })
        }
    }else if(to.matched.some(r => r.meta.secretKey)) {
        const _secretKey = cookie.get('secretKey');
        if( _secretKey ){
            next();
        }else{
            next({
                path: '/entrance/login',
                query: {
                    redirect: to.fullPath
                }
            })
        }
    }else if(to.matched.some(r => r.meta.ticketcheckSecretKey)) {
        const _secretKey = cookie.get('ticketcheckSecretKey');
        if( _secretKey ){
            next();
        }else{
            next({
                path: '/Ticketcheck/login',
                query: {
                    redirect: to.fullPath
                }
            })
        }
    }else if(to.matched.some(r => r.meta.viteDataSecretKey)) {
        const _secretKey = cookie.get('viteDataSecretKey');
        if( _secretKey ){
            next();
        }else{
            next({
                path: '/viteData/login',
                query: {
                    redirect: to.fullPath
                }
            })
        }
    }
	else if(to.matched.some(r => r.meta.entryDataSecretKey)) {
        const _secretKey = cookie.get('entryDataSecretKey');
        if( _secretKey ){
            next();
        }else{
            next({
                path: '/entryData/login',
                query: {
                    redirect: to.fullPath
                }
            })
        }
    }else {
        next()
    }
})

//异常处理
router.onError(async error => {
    if (error.toString().indexOf('ChunkLoadError') === -1) {
        return;
    }

    const flag = await MessageBox.confirm('服务器版本已经更新，页面刷新后可以恢复正常使用', '提示', {
        confirmButtonText: '立即刷新',
        cancelButtonText: '取消',
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        center: true
    }).catch(() => 'cancel');

    if (flag === 'cancel') {
        return;
    }

    window.location.reload();
})

// 发版后旧 chunk 被删除时, 部分静态服务/网关会把 404 回退成 index.html, 浏览器把 HTML 当 JS 解析
// 直接抛 "SyntaxError: Unexpected token '<'"; 这类错误不属于 ChunkLoadError, 上面的 onError 抓不到,
// 用户会停在白屏/半渲染状态, 这里在全局错误里补一层兜底
function isChunkParseError(message, filename) {
    if (!message || message.indexOf("Unexpected token '<'") === -1) {
        return false;
    }
    return !!filename && filename.indexOf('/fbStatic/') !== -1;
}

function reloadForChunkParseError() {
    // 同一标签页 1 分钟内只自动刷新一次, 避免静态服务持续异常时无限刷新
    try {
        const last = Number(sessionStorage.getItem('chunk_reload_at') || 0);
        if (Date.now() - last < 60000) {
            console.warn('[chunk-reload] 1 分钟内已自动刷新过, 本次跳过');
            return;
        }
        sessionStorage.setItem('chunk_reload_at', String(Date.now()));
    } catch (e) {
        console.warn('[chunk-reload] sessionStorage 不可用, 跳过自动刷新');
        return;
    }
    window.location.reload();
}

window.addEventListener('error', function (event) {
    if (isChunkParseError(event.message, event.filename)) {
        // 用 error 级输出, 随 [FE] 通道落到线上错误日志, 便于排查发版窗口白屏
        console.error('[chunk-reload] 旧 chunk 解析失败, 触发自动刷新', event.message, event.filename);
        reloadForChunkParseError();
    }
}, true);

export default router